/* Sucker Punch — Mints PDP picker (rev 2026-07-08).
   HARD RULE (feedback_picker_must_fire_pixels.md):
   custom pickers MUST manually fire fbq/GA4/webPixels/tiktok + dispatch cart:item-added.
*/
(function () {
  const root = document.querySelector('.mints-pdp');
  if (!root) return;

  const state = {
    pack: 1,
    oneFlavor: 'Strawberry',
    slots: [null, null, null],
  };

  const V = {
    Strawberry: root.dataset.vStrawberry,
    Pineapple:  root.dataset.vPineapple,
    Watermelon: root.dataset.vWatermelon,
    ThreePack:  root.dataset.vThreepack || root.getAttribute('data-v-threepack'),
  };
  const PRICE_1 = parseFloat(root.dataset.price1);
  const PRICE_3 = parseFloat(root.dataset.price3);

  const PRODUCT_ID     = root.dataset.productId;
  const PRODUCT_HANDLE = root.dataset.productHandle;
  const PRODUCT_TITLE  = root.dataset.productTitle;

  const chipClass = { Strawberry: 'strawberry', Pineapple: 'pineapple', Watermelon: 'watermelon' };
  const chipGrads = {
    Strawberry: 'radial-gradient(circle at 30% 30%,#ffb0bd,#e54764 55%,#a8253c)',
    Pineapple:  'radial-gradient(circle at 30% 30%,#fff5b1,#f4d641 55%,#bd9a10)',
    Watermelon: 'radial-gradient(circle at 30% 30%,#c4f0a5,#5bb84d 55%,#2c7a26)'
  };

  const fmt = (n) => '$' + Number(n).toFixed(2);

  function render() {
    // pack toggle
    root.querySelectorAll('#mintsPackToggle button').forEach(b => {
      b.classList.toggle('on', +b.dataset.pack === state.pack);
    });

    root.querySelector('#mintsOnePack').style.display = state.pack === 1 ? '' : 'none';
    root.querySelector('#mintsThreePack').classList.toggle('on', state.pack === 3);

    const p = state.pack === 1 ? PRICE_1 : PRICE_3;
    root.querySelector('#mintsDisplayPrice').textContent = fmt(p);
    root.querySelector('#mintsAtcPrice').textContent    = fmt(p);
    const stickyPriceEl = root.querySelector('#mintsStickyPrice');
    if (stickyPriceEl) stickyPriceEl.textContent = fmt(p);

    let line;
    if (state.pack === 1) {
      line = '1-Pack · ' + state.oneFlavor;
    } else {
      const filled = state.slots.filter(Boolean);
      line = filled.length === 3
        ? '3-Pack · ' + state.slots.join(' · ')
        : '3-Pack · Pick ' + (3 - filled.length) + ' more';
    }
    const stickyLineEl = root.querySelector('#mintsStickyLine');
    if (stickyLineEl) stickyLineEl.textContent = line;

    // 1-pack flavor tile state
    root.querySelectorAll('#mintsFlavors1 .mints-flavor').forEach(el => {
      el.classList.toggle('on', el.dataset.flavor === state.oneFlavor);
    });

    // slot state
    root.querySelectorAll('#mintsSlots .mints-slot').forEach((el, i) => {
      const val = state.slots[i];
      el.classList.toggle('filled', !!val);
      el.querySelector('.s-name').textContent = val || 'Pick a flavor';
      const chip = el.querySelector('.s-chip');
      chip.style.background = val ? chipGrads[val] : '#222';
    });

    const ok = state.pack === 1 ? true : state.slots.every(Boolean);
    root.querySelector('#mintsAtc').disabled = !ok;
  }

  // variant images (2026-10-03): each flavor button / the 3-pack toggle carries data-img (+ data-srcset) =
  // that variant's featured image; picking a flavor or pack shows it in the main image. Additive only.
  function showVariantImg() {
    const el = state.pack === 3
      ? root.querySelector('#mintsPackToggle button[data-pack="3"]')
      : root.querySelector('#mintsFlavors1 .mints-flavor[data-flavor="' + state.oneFlavor + '"]');
    const main = root.querySelector('#mintsMainImg');
    if (!el || !main || !el.dataset.img) return;
    if (el.dataset.srcset) { main.setAttribute('srcset', el.dataset.srcset); main.setAttribute('sizes', '(min-width: 900px) 50vw, 100vw'); }
    main.src = el.dataset.img;
    root.querySelectorAll('#mintsThumbs .mints-thumb').forEach(x => x.classList.remove('active'));
  }

  // pack toggle
  root.querySelectorAll('#mintsPackToggle button').forEach(b => {
    b.addEventListener('click', () => { state.pack = +b.dataset.pack; render(); showVariantImg(); });
  });
  // 1-pack flavor
  root.querySelectorAll('#mintsFlavors1 .mints-flavor').forEach(b => {
    b.addEventListener('click', () => { state.oneFlavor = b.dataset.flavor; render(); showVariantImg(); });
  });
  // slots
  root.querySelectorAll('#mintsSlots .mints-slot').forEach((el, i) => {
    el.querySelector('select').addEventListener('change', e => {
      state.slots[i] = e.target.value || null; render();
    });
  });
  // one of each
  const oneOf = root.querySelector('#mintsOneOfEach');
  if (oneOf) oneOf.addEventListener('click', () => {
    state.slots = ['Strawberry', 'Pineapple', 'Watermelon'];
    root.querySelectorAll('#mintsSlots .mints-slot').forEach((el, i) => {
      el.querySelector('select').value = state.slots[i];
    });
    render();
  });
  // gallery
  root.querySelectorAll('#mintsThumbs .mints-thumb').forEach(b => {
    b.addEventListener('click', () => {
      root.querySelectorAll('#mintsThumbs .mints-thumb').forEach(x => x.classList.remove('active'));
      b.classList.add('active');
      root.querySelector('#mintsMainImg').removeAttribute('srcset'); // a variant srcset would override the thumb's src
      root.querySelector('#mintsMainImg').src = b.dataset.src;
    });
  });

  // ===== ATC =====
  root.querySelector('#mintsAtc').addEventListener('click', async () => {
    const btn = root.querySelector('#mintsAtc');
    const origLabel = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = 'Adding…';

    let payload;
    if (state.pack === 1) {
      payload = {
        items: [{
          id: parseInt(V[state.oneFlavor].replace(/\D/g, ''), 10),
          quantity: 1
        }]
      };
    } else {
      // 3-Pack Bundle: single line item, flavors as line-item properties
      payload = {
        items: [{
          id: parseInt((V.ThreePack || '').replace(/\D/g, ''), 10),
          quantity: 1,
          properties: {
            'Tin 1': state.slots[0],
            'Tin 2': state.slots[1],
            'Tin 3': state.slots[2],
            'Flavors': state.slots.join(' · ')
          }
        }]
      };
    }

    try {
      const r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      });
      const data = await r.json();
      if (!r.ok) throw new Error(data.description || data.message || 'Add to cart failed');

      // Fire tracking pixels for every added item (feedback_picker_must_fire_pixels.md)
      const items = Array.isArray(data.items) ? data.items : [data];
      const value = state.pack === 1 ? PRICE_1 : PRICE_3;

      items.forEach(it => {
        // Meta Pixel
        try {
          if (window.fbq) window.fbq('track', 'AddToCart', {
            content_ids: [it.product_id || PRODUCT_ID],
            content_type: 'product',
            content_name: it.product_title || PRODUCT_TITLE,
            value: value,
            currency: 'USD'
          });
        } catch (e) {}

        // GA4 / Google Tag Manager
        try {
          if (window.dataLayer) window.dataLayer.push({
            event: 'add_to_cart',
            ecommerce: {
              currency: 'USD',
              value: value,
              items: [{
                item_id: it.variant_id || it.id,
                item_name: it.product_title || PRODUCT_TITLE,
                item_variant: it.variant_title,
                quantity: it.quantity || 1,
                price: (it.price || 0) / 100
              }]
            }
          });
        } catch (e) {}

        // Shopify Web Pixels (theme sales channel)
        try {
          if (window.webPixelsManager) {
            window.webPixelsManager.publish('product_added_to_cart', {
              cartLine: {
                cost: { totalAmount: { amount: value, currencyCode: 'USD' } },
                merchandise: {
                  id: 'gid://shopify/ProductVariant/' + (it.variant_id || it.id),
                  product: { id: 'gid://shopify/Product/' + (it.product_id || PRODUCT_ID), title: it.product_title || PRODUCT_TITLE },
                  title: it.variant_title,
                  price: { amount: (it.price || 0) / 100, currencyCode: 'USD' }
                },
                quantity: it.quantity || 1
              }
            });
          }
        } catch (e) {}

        // TikTok Pixel
        try {
          if (window.ttq) window.ttq.track('AddToCart', {
            content_id: it.variant_id || it.id,
            content_type: 'product',
            content_name: it.product_title || PRODUCT_TITLE,
            quantity: it.quantity || 1,
            price: (it.price || 0) / 100,
            value: value,
            currency: 'USD'
          });
        } catch (e) {}
      });

      // Theme cart-drawer refresh event (Dawn/Ride convention)
      document.documentElement.dispatchEvent(new CustomEvent('cart:item-added', {
        detail: { items: items, source: 'mints-pdp' },
        bubbles: true
      }));

      // Some themes listen for this
      document.dispatchEvent(new CustomEvent('cart:refresh'));

      // Update header cart count
      try {
        const cart = await fetch('/cart.js').then(r => r.json());
        document.querySelectorAll('[class*="cart-count"], .cart-link__bubble, .cart-count-bubble, [data-cart-count]').forEach(el => {
          const num = cart.item_count;
          if (el.hasAttribute('data-cart-count')) el.setAttribute('data-cart-count', num);
          el.textContent = num;
        });
      } catch (e) {}

      btn.innerHTML = '✓ Added';
      setTimeout(() => { btn.innerHTML = origLabel; btn.disabled = false; }, 1200);
    } catch (e) {
      console.error('[mints-pdp] add-to-cart failed', e);
      btn.innerHTML = 'Try again';
      setTimeout(() => { btn.innerHTML = origLabel; btn.disabled = false; }, 1500);
    }
  });

  // honor ?variant=<id> on load: preselect that flavor (or the 3-pack) + its image + price
  try {
    const qv = new URLSearchParams(window.location.search).get('variant');
    if (qv) {
      const hit = Object.keys(V).find(k => String(V[k]) === String(qv));
      if (hit === 'ThreePack') { state.pack = 3; }
      else if (hit) { state.pack = 1; state.oneFlavor = hit; }
      if (hit) { render(); showVariantImg(); }
    }
  } catch (e) {}

  render();
})();
